/**
 * twitchEmotes — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const twitchEmotesPack: ToilePack = {
    slug: 'twitch-emotes',
    category: 'emotes',
    name: 'Twitch emotes',
    tagline: tagline('emote sheets', 'characters', 'styles'),
    chips: chips('characters', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'cat', label: 'Cat', subject: 'a round cartoon cat in six expressions, laughing to shocked'},
        {key: 'frog', label: 'Frog', subject: 'a round cartoon frog in six expressions, smug to waving'},
        {key: 'ghost', label: 'Ghost', subject: 'a small cartoon ghost in six expressions, giggling to cheering'},
    ],
    styles: [
        {key: 'glossy', label: 'Chibi glossy', style: 'chibi with glossy shading and inner glow', palette: 'saturated candy colors', framing: '3×2 grid, readable at 28 pixels'},
        {key: 'sticker', label: 'Flat sticker', style: 'flat sticker look, solid fills', palette: 'no gradients, thick white outline', framing: '3×2 grid, readable at 28 pixels'},
        {key: 'drawn', label: 'Hand-drawn', style: 'hand-drawn, wobbly ink outlines', palette: 'marker coloring, paper grain', framing: '3×2 grid, readable at 28 pixels'},
    ],
    directions: ['a shiba dog instead', 'in purple and cream', 'more extreme expressions'],
}
